module.exports = __webpack_public_path__ + "img/flightaway_infos.8e4df0b4.svg";